"use client"

import * as React from "react"

export type CheckboxVariant = "default" | "glass"

export type CheckboxProps = React.InputHTMLAttributes<HTMLInputElement> & {
  isInvalid?: boolean
  variant?: CheckboxVariant
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className = "", isInvalid = false, variant = "default", ...props }, ref) => {
    const baseDefault =
      "h-5 w-5 aspect-square rounded-sm border transition focus:outline-hidden focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 dark:bg-zinc-900"
    const bordersDefault = isInvalid
      ? "border-red-500 focus-visible:ring-red-500"
      : "border-slate-300 dark:border-zinc-700"

    const baseGlass =
      "relative h-5 w-5 aspect-square rounded-md border border-white/40 bg-white/15 backdrop-blur-md transition duration-200 ease-out focus:outline-hidden focus-visible:ring-2 focus-visible:ring-white/60 focus-visible:ring-offset-0"
    const stateGlass = isInvalid
      ? "border-red-400 focus-visible:ring-red-400"
      : "hover:border-white/70"
    const checkedGlass =
      "checked:bg-brand checked:border-brand checked:shadow-[0_0_0_1px_rgba(255,255,255,0.4)] checked:[&::after]:content-[''] checked:[&::after]:absolute checked:[&::after]:inset-0 checked:[&::after]:m-auto checked:[&::after]:h-2.5 checked:[&::after]:w-1.5 checked:[&::after]:rotate-45 checked:[&::after]:border-b-2 checked:[&::after]:border-r-2 checked:[&::after]:border-white"

    const variantClass =
      variant === "glass"
        ? [baseGlass, stateGlass, checkedGlass, "appearance-none"].join(" ")
        : [baseDefault, bordersDefault].join(" ")

    return (
      <input
        ref={ref}
        type="checkbox"
        className={[variantClass, className].join(" ")}
        data-variant={variant}
        {...props}
      />
    )
  },
)
Checkbox.displayName = "Checkbox"
